import { Params } from '@angular/router';
import { Facet, FacetConfigResponse as FacetGroup } from '@models/api-search.models';

/**
 * Converts input to Params output can be in the following formats
 * Output: { brand.da.keyword: 'Lyngby' }
 * Output: { brand.da.keyword: [ 'Lyngby', 'Royal Copenhagen' ] }
 * Output: { brand.da.keyword: null }
 * @param key
 * @param facets
 */
export const facetGroupToParam = (key: string, facets: Facet[]): Params => {
    const values = facets.reduce((prev: (string | undefined)[], curr: Facet) => {
        if (curr.selected) {
            prev.push(curr.key);
        }
        return prev;
    }, []);

    return { [key]: values.length ? (values.length > 1 ? values : values[0]) : null };
};

/**
 * Removes specific value from param
 * @param group
 * @param val
 * @example removeFacetValueParam(group, 'Lyngby')
 * Output: { brand.da.keyword: [ 'Royal Copenhagen', Nordisk Tekstil ] }
 * If value removed is last, output value will be null
 */
export const removeParamFacetValue = (group: FacetGroup, val: string): Params | void => {
    if (!group.key) {
        return;
    }

    const selectedValues = group.values?.reduce((prev: (string | undefined)[], curr: Facet) => {
        if (curr.selected && curr.key !== val) {
            prev.push(curr.key);
        }

        return prev;
    }, []);

    return { [group.key]: selectedValues?.length ? selectedValues : null };
};
